import ApiCall from './middleware';
import buildQueryParams from "../utils/queryParams";
import { API_METHOD } from '../utils/enums';
import { CausePreferenceAPIProps, DonationFormProps, ManageAccountFormikProps, PersonalFundraiserEditFormikProps, TopRatedNonprofitParamsProps } from '../utils/types';

const STATIC_API_URL = import.meta.env.VITE_STATIC_API_URL;
const API_URL = import.meta.env.VITE_API_URL;

export const subscribeApi = (data: any) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}newsletter`, body: data });
};
export const modulesAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}module-flags` });
};

export const totalDonationCampCount = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}compaign-count` });
};

export const donationCampCategory = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}causes` });
};

export const blogCategory = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}blog/category-list` });
};

export const blogDetailApi = (id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}blog/${id}` });
};

export const latestArticle = (page: number, limit: number, category: string, search: string) => {
  const params = { page, limit, category, search };
  const queryParams = buildQueryParams(params);
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}blogs${queryParams}` });
};

export const nearestCitiesAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}nearest-cities` });
};

export const nearByCitiesAPI = (zipcode = "") => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}near-by-cities?zipcode=` + zipcode });
};

export const topCausesAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}top-causes` });
};

export const topCitiesAPI = (stateName = "") => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}top-cities?state=` + stateName });
};

export const countriesAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}countries` });
};
export const statesAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}states` });
};
export const issuesAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}issue` });
};
export const confirmAddressAPI = (org_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}confirm-address/${org_id}` });
};
export const addEditFavouriteAPI = (user_id: string, org_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}add-remove-favorg/${user_id}/${org_id}` });
};
export const claimNonprofitAPI = (org_id: string) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}generate-claim-req`, body: { org_id } });
};
export const topRatedNonprofitsAPI = (body: TopRatedNonprofitParamsProps) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}top-rated-organizations`, body });
};
export const topRatedFiltersAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}toprated-filters` });
};

export const nonprofitProfileListAPI = (org_id: any) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}nonprofit-slug/${org_id}` });
}

export const nonprofitsListApi = (
  params: {
    all?: boolean,
    search?: string,
    country?: string,
    state?: string,
    city?: string,
    zipcode?: string,
    category?: number | string,
    sortBy?: string,
    page?: number,
    limit?: number
  }
) => {
  const queryParams = buildQueryParams(params);

  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}nonprofits${queryParams}` });
};

export const allCategoriesAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}all-causes` });
};
export const allNonprofitsAPI = (body: { browse_by: string; page: number; size: number }) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}all-orgs`, body });
};
export const userFavNonprofitsAPI = (user_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}favorite-orgs/${user_id}` });
};
export const similarNonprofitsListApi = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}nonprofits` });
};

export const signupAPI = (data: any) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}signup`, body: data });
};

export const similarNonprofitsAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}featured-review` });
};

export const loginAPI = (data: any) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}login`, body: data });
};

export const resetPasswordAPI = (data: any) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}password-reset`, body: data });
};

export const forgotAPI = (data: any) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}send-email`, body: data });
};

export const socialLoginAPI = (data: any) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}social-login`, body: data });
};

export const campCities = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}cities` });
};

export const ipAddressAPI = (data: any) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}ip-address`, body: data });
};

export const donateToAPI = (order_id: string, donation_id?: string) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}paypal/capture-order/${order_id}${donation_id ? "?donation_id=" + donation_id : ""}` });
};

export const donatedNonprofitAPI = (payment_id: string) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}donated-nonprofits`, body: { payment_id } });
};

export const yearlyCampaign = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}campaigns` });
};

export const campCauses = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}top-causes` });
};

export const searchNonprofitsAPI = (searchString: any, zipCodeVal: any) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}search-nonprofit`, body: { search: searchString, zipCode: zipCodeVal } });
};

export const donateCartsAPI = (donation_id?: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}donation-in-cart${donation_id ? "?donation_id=" + donation_id : ""}`, });
};

export const addCartDonatesAPI = (data: { org_id: string, amount: number }) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}donation-in-cart`, body: data });
};
export const editCartDonatesAPI = (donation_id: string, body: DonationFormProps) => {
  return ApiCall({ type: API_METHOD.PUT, url: `${API_URL}donation-update/${donation_id}`, body });
};
export const deleteCartDonatesAPI = (donation_id: string) => {
  return ApiCall({ type: API_METHOD.DELETE, url: `${API_URL}donation-update/${donation_id}` });
};

export const contactUsAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}contact-us` });
};

export const campDetailsAPI = (slug: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}nonprofit/${slug}` });
};
export const campDetailsByIdAPI = (org_id: any) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}nonprofit-profile/${org_id}` });
};

export const reviewRolesListAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}review-roles` });
};
export const communityStoriesAPI = (org_id: string, role: any, page: number, size: number) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}reviews/${org_id}`, body: { role, page, size } });
};
export const storiesUpVoteAPI = (review_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}up-vote-review/${review_id}` });
};
export const addStoryCommentAPI = (review_id: string, body: any) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}add-comments/${review_id}`, body });
};
export const flagStoryAPI = (review_id: string, body: any) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}flag-review/${review_id}`, body });
};
export const addEditReviewsAPI = (org_id: string, body: any) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}reviews/${org_id}`, body, mimeType: "multipart/form-data" });
};

export const listReviewsAPI = (review_id: any) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}review/${review_id}` });
};
export const deleteReviewsAPI = (review_id: any, unpublish: any) => {
  const url = unpublish
    ? `${API_URL}review/${review_id}?unpublish=True`
    : `${API_URL}review/${review_id}`;
  return ApiCall({ type: API_METHOD.DELETE, url: url });
};

export const updateReviewsAPI = (review_id: string, body: any) => {
  return ApiCall({ type: API_METHOD.PUT, url: `${API_URL}review/${review_id}`, body, mimeType: "multipart/form-data" });
};
export const retrieveReviewsAPI = (review_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}review/${review_id}` });
};

export const sponsorsAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}sponsors-list` });
};

export const starBadgeAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}star-badge` });
};

export const badgeStatisticsAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}nonprofits-badge-statistics` });
};

export const successStoriesAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}nonprofit-success-stories` });
};

export const elliottAdvocacyAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}elliott-advocacy` });
};

export const greatNonProfitAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}about-great-nonprofit` });
};

export const aboutMembersAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}about-members` });
};

export const nonprofitMissionAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}nonprofit-mission` });
};

export const pressMediaAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}press-media` });
};

export const fundersAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}funders` });
};

export const clientsAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}clients` });
};

export const solutionsAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}partner-solution` });
};

export const supportersAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}supporters` });
};

export const donationNumbersAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}donation-numbers` });
};

export const donationDifferenceAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}donation-make-difference` });
};

export const careersAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}careers` });
};

export const endorsementsAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}endorsements-testimonials` });
};

export const faqHelpsAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}faq-helps` });
};

export const faqArticlesAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}faq-articles` });
};

export const faqUserGuideAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}faq-user-guid` });
};

export const faqTopRatedAwardsAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}faq-topRated-awards` });
};

export const faqNonprofitAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}faq-nonprofit` });
};

export const faqDetailsAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}faq-detail` });
};

export const advertisingAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}advertising` });
};

export const linkToUsAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}link-to-us` });
};

export const yearBadgeAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}year-badge` });
};

export const getBadgeAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}get-badge` });
};

export const contactUsFaqAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}faqs` });
};

export const myReviewAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${STATIC_API_URL}my-review` });
};

export const userProfileReviewAPI = (user_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}user-reviews/${user_id}` });
};

export const myDonationAPI = (user_id: string, body?: { start_date: string | null, end_date: string | null }) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}user-donations/${user_id}`, body });
};
export const allCausePreferenceAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}cause-preferences` });
};
export const userCausePreferenceAPI = (user_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}user-preferences/${user_id}` });
};
export const updateCausePreferenceAPI = (user_id: string, body: CausePreferenceAPIProps) => {
  return ApiCall({ type: API_METHOD.PUT, url: `${API_URL}user-preferences/${user_id}`, body });
};

export const accountDetailAPI = (user_id: any) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}user-profile/${user_id}` });
};
export const userProfileStateAPI = (user_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}user-profile-state/${user_id}` });
};
export const updateAccDetailAPI = (user_id: string, body: ManageAccountFormikProps) => {
  return ApiCall({ type: API_METHOD.PUT, url: `${API_URL}user-profile/${user_id}`, body, mimeType: "multipart/form-data" });
};
export const verifyEmailAPI = (token: string) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}email-verification`, body: { token } });
};
export const sendVerificationMailAPI = (body: {
  email: string,
  link: string
}) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}email-verification-mail`, body });
};

export const createFundraiserAPI = (user_id: string, body: PersonalFundraiserEditFormikProps) => {
  return ApiCall({ type: API_METHOD.POST, url: `${API_URL}personal-fundraisers/${user_id}`, body, mimeType: "multipart/form-data" });
}
export const updateFundraiserAPI = (user_id: string, org_id: string, body: PersonalFundraiserEditFormikProps) => {
  return ApiCall({ type: API_METHOD.PUT, url: `${API_URL}personal-fundraiser/${user_id}/${org_id}`, body, mimeType: "multipart/form-data" });
};
export const unpublishFundraiserAPI = (user_id: string, org_id: string) => {
  return ApiCall({ type: API_METHOD.DELETE, url: `${API_URL}personal-fundraiser/${user_id}/${org_id}` });
};
export const personalFundraiserAPI = (user_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}personal-fundraisers/${user_id}` });
};

export const fundRaiserDetailAPI = (user_id: string, org_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}personal-fundraiser/${user_id}/${org_id}` });
};

export const fundRaiserViewDetailAPI = (id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}fundraiser/${id}` });
}

export const nonprofitDonationAPI = (org_id: string, body: { type: number }) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}donations/${org_id}`, body: body });
};

export const nonprofitMediaAPI = (org_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}user-gallery/${org_id}` });
};

export const uploadNonprofitMediaAPI = (org_id: string, body: any) => {
  return ApiCall({ type: API_METHOD.PUT, url: `${API_URL}user-media-upload/${org_id}`, body, mimeType: "multipart/form-data" });
};

export const userNonprofitListAPI = () => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}user-nonprofits` });
};

export const nonprofitStatsAPI = (org_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}user-nonprofit-state/${org_id}` });
};

export const editNonprofitProfileAPI = (org_id: string, body: any) => {
  return ApiCall({ type: API_METHOD.PUT, url: `${API_URL}nonprofit-profile/${org_id}`, body });
};

export const fetchNonprofitProfileAPI = (org_id: string) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}nonprofit-profile/${org_id}` });
};

export const featuredReviewAPI = (review_id: any) => {
  return ApiCall({ type: API_METHOD.GET, url: `${API_URL}featured-review/${review_id}` });
};
